import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Footer';
import useRouteMeta from '../../../hooks/useRouteMeta';
import './AppDownloadPage.css';

const AppDownloadPage = () => {
  useRouteMeta();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="app-download-page">
      {/* ── Background Vectors (as seen in marked mockup) ── */}
      <div className="adp-vector adp-v1"><img src="/assets/img/website/fixed-vector.svg" alt="" /></div>
      <div className="adp-vector adp-v2"><img src="/assets/img/website/fixed-vector.svg" alt="" /></div>
      <div className="adp-vector adp-v3"><img src="/assets/img/website/fixed-vector.svg" alt="" /></div>
      <div className="adp-vector adp-v4"><img src="/assets/img/website/fixed-vector.svg" alt="" /></div>

      {/* ── Logo-only header ── */}
      <nav className="adp-navbar">
        <div className="adp-navbar-inner">
          <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img
              src="/assets/img/glammify-logo.png"
              alt="Glammify Logo"
              className="adp-navbar-logo"
            />
          </Link>
        </div>
      </nav>

      <main className="adp-main">
        <h1 className="adp-title">Download Our App</h1>
        <p className="adp-subtitle">
          Experience faster, smarter, and seamless access on your mobile.
        </p>

        {/* Device Image */}
        <div className="adp-mockup-container">
          <img
            src="/assets/img/website/MacBook_Pro.svg"
            alt="Glammify on MacBook"
            className="adp-device-img adp-desktop-only"
          />
          <img
            src="/assets/img/website/iPad_Air_5.svg"
            alt="Glammify Devices"
            className="adp-device-img adp-mobile-only"
          />
        </div>

        {/* Download Buttons */}
        <div className="adp-buttons">
          <a
            href="https://apps.apple.com/vu/app/glammify-ai/id6751037508"
            target="_blank"
            rel="noopener noreferrer"
            className="adp-dl-btn"
          >
            <img src="/assets/img/website/ic_baseline-apple.svg" alt="Apple" className="adp-dl-btn-icon" />
            <div className="adp-dl-btn-text">
              <span className="adp-dl-btn-small">Download on the</span>
              <span className="adp-dl-btn-big">App Store</span>
            </div>
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.glammify.app&hl=en_IN"
            target="_blank"
            rel="noopener noreferrer"
            className="adp-dl-btn"
          >
            <img src="/assets/img/website/uil_android.svg" alt="Android" className="adp-dl-btn-icon" />
            <div className="adp-dl-btn-text">
              <span className="adp-dl-btn-small">Get it on</span>
              <span className="adp-dl-btn-big">Google Play</span>
            </div>
          </a>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default AppDownloadPage;
